import { MeshCssFeature } from './mesh.types'
import { meshDomApplier } from './meshDomApplier'
import { mesh } from './meshCompNode'
import { meshChild } from './meshChildCompNode'
import { autoHeightWrapper } from '../autoHeightWrapper/autoHeightWrapperCompNode'

export const meshCssFeature: MeshCssFeature = {
	experimentName: 'specs.thunderbolt.mesh_css_catharsis',
	renderableNodes: { mesh: mesh(false) },
	intermediateNodes: { meshChild: meshChild(false), autoHeightWrapper },
	dataMaps: ['theme_data', 'component_properties', 'document_data'],
	domApplier: meshDomApplier,
}

export const editorMeshCssFeature: MeshCssFeature = {
	...meshCssFeature,
	renderableNodes: { mesh: mesh(true) },
	intermediateNodes: { meshChild: meshChild(true), autoHeightWrapper },
}
